import React from 'react'
import { FilesAssetsDashboard } from '../../components/filesAssets'

const FilesAssetsPage: React.FC = () => {
  return <FilesAssetsDashboard />
}

export default FilesAssetsPage
